import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../DataLayer/DataLayer";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "10px",
  border: "none",
  boxShadow: 24,
  p: 4,
};

function isHTML(str) {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}

const UserAPILogEdit = ({ record, handleUpdate, handleAdd }) => {
  const [route, setRoute] = useState(record?.route);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [, dispatch] = useDataLayerValue();

  useEffect(() => {
    if (record) {
      setRoute(record?.route);
    } else {
      setRoute("");
    }
  }, [record, open]);
  return (
    <>
      <div className="table_action_btn" style={{ display: "flex" }}>
        {record ? (
          <div
            className="btn"
            onClick={() => {
              handleOpen();
            }}
          >
            <i
              className="ri-edit-2-line"
              data-toggle="tooltip"
              title="Edit"
            ></i>
          </div>
        ) : (
          <div
            className="btn add_v_btn"
            onClick={() => {
              handleOpen();
            }}
          >
            Add API
          </div>
        )}
      </div>

      <Modal
        open={open}
        onClose={(e) => {
          handleClose();
        }}
        sx={{ border: "none" }}
      >
        <Box sx={style}>
          {isHTML() ? (
            <h4
              style={{ fontWeight: "bold" }}
              dangerouslySetInnerHTML={{ __html: "Edit API " }}
            />
          ) : (
            <h4 style={{ fontWeight: "bold" }}>
              {record ? "Edit" : "Add"} API 
            </h4>
          )}
          <form className="input_form">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="fieldrow">
                  <label className="f_label">Route</label>
                  <input
                    required
                    value={route}
                    onChange={(e) => {
                      setRoute(e.target.value);
                    }}
                    type="text"
                    className="f_input"
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "right",
                marginTop: "10%",
              }}
            >
              <Button
                variant="contained"
                onClick={(e) => {
                  handleClose();
                  try {
                    if (record?.id) handleUpdate(record.id, { route });
                    else handleAdd({ route, isLog: 1 });
                    setRoute("");
                  } catch (error) {
                    dispatch({
                      type: "SET_LOADING",
                      loading: false,
                    });

                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: error.message,
                    });
                  }
                }}
              >
                Save
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
      {/* </form> */}
    </>
  );
};

export default UserAPILogEdit;
